import React from "react";
import AppConstants from "../../constants/AppConstants";
import BlockUtils from "../../utils/BlockUtils";
import Block from "./Block.jsx";
import Background from "./Background.jsx";
const { BLOCK_PROP_PARENT_BLOCK_ID } = AppConstants;

const Page = ({ blocks, designContext, layout, layoutWidth, theme, background, buttonState, mode }) => {
  const viewBlocks = [];

  if (blocks != null) {
    let pageBlockCount = 0;
    let siteBlockCount = 0;
    blocks.forEach((block) => {
      const blockId = block.get("id");
      if (BlockUtils.isVisibleInLayout(block, layout)) {
        const isSiteCanvas = block?.get(BLOCK_PROP_PARENT_BLOCK_ID) !== undefined;
        if (isSiteCanvas) {
          siteBlockCount++;
        } else {
          pageBlockCount++;
        }
        const blockElement = (
          <Block
            key={`page-block-${blockId}`}
            block={block}
            dataTestId={`${layout}-${isSiteCanvas ? "site" : "page"}-block-${
              isSiteCanvas ? siteBlockCount : pageBlockCount
            }`}
            layout={layout}
            layoutWidth={layoutWidth}
            theme={theme}
            designContext={designContext}
            buttonState={buttonState}
            mode={mode}
          />
        );
        viewBlocks.push(blockElement);
      }
    });
  }

  return (
    <div id="si_page_content">
      <Background
        background={background}
        layout={layout}
        width={layoutWidth}
        theme={theme}
        designContext={designContext}
      />
      {viewBlocks}
    </div>
  );
};

export default Page;
